import { styled } from 'twin.macro';

const MarkdownHorizontalRule = styled.hr`
    border-style: solid;
    border-top-width: 0px;
    color: rgb(255 255 255 / 0.5);
`;

export default MarkdownHorizontalRule;
